import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputProps,
  NumberInputStepper,
} from '@chakra-ui/react';
import { Controller } from 'react-hook-form';

interface NumberInputFormProps extends NumberInputProps {
  name: string | undefined | any;
  label: string | undefined;
  placeholder?: string;
  isRequired?: boolean;
  control: any;
  errors: any;
}

export const NumberInputForm = ({
  name,
  label,
  placeholder,
  isRequired,
  control,
  errors,
  ...rest
}: NumberInputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!errors[name]}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <NumberInput {...field} {...rest}>
            <NumberInputField placeholder={placeholder} />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      />

      {errors[name] && <FormErrorMessage>{errors[name]?.message}</FormErrorMessage>}
    </FormControl>
  );
};
